/**
 * Build a video poster URL (JPEG of frame ~1.5s) from a Cloudinary video URL.
 * Allows <video poster="..."> for instant visual feedback without preloading.
 */
export function videoPoster(url) {
  if (!url || !url.includes("res.cloudinary.com")) return null;
  // /video/upload/<existing>/<rest>.mp4 → /video/upload/so_1.5,f_jpg,q_auto:good,w_900/<rest>.jpg
  const marker = "/video/upload/";
  const idx = url.indexOf(marker);
  if (idx === -1) return null;
  const head = url.slice(0, idx + marker.length);
  let tail = url.slice(idx + marker.length);
  const parts = tail.split("/");
  if (parts[0] && !parts[0].match(/^v\d+$/) && parts[0].match(/[a-z]_/)) {
    tail = parts.slice(1).join("/");
  }
  // Strip extension and replace with .jpg
  tail = tail.replace(/\.[a-zA-Z0-9]+$/, ".jpg");
  return `${head}so_1.5,f_jpg,q_auto:eco,w_700,c_limit/${tail}`;
}

/**
 * Build multiple video sources for responsive delivery.
 * ac_none strips audio at delivery time — videos in the gallery have no sound on purpose.
 * Returns array of { src, media } pairs suitable for <source media="..." src="..." />
 */
export function videoSources(url) {
  if (!url) return [];
  if (!url.includes("res.cloudinary.com")) return [{ src: url }];
  const make = (preset) => {
    const marker = "/video/upload/";
    const idx = url.indexOf(marker);
    const head = url.slice(0, idx + marker.length);
    let tail = url.slice(idx + marker.length);
    const parts = tail.split("/");
    if (parts[0] && !parts[0].match(/^v\d+$/) && parts[0].match(/[a-z]_/)) {
      tail = parts.slice(1).join("/");
    }
    return `${head}${preset}/${tail}`;
  };
  return [
    { src: make("ac_none,f_auto,q_auto:eco,w_540,c_limit"),  media: "(max-width: 640px)" },
    { src: make("ac_none,f_auto,q_auto:eco,w_1100,c_limit") },
  ];
}
